import { formatBranchAddress } from './branch';

import { PhysicalUnitAddress } from '@/app/(main)/(pages)/(home)/_types';

interface Params {
  key: string;
  value: string;
}

interface GenerateLinkProps {
  url: string;
  params: Params[];
}

export function generateLink({ url, params }: GenerateLinkProps) {
  const link = new URL(url);

  params.forEach(({ key, value }) => {
    link.searchParams.append(key, value);
  });

  return link.href;
}

export function generateGoogleMapsUrl(address: PhysicalUnitAddress): string {
  const addressFormated = formatBranchAddress(address);
  const encodedAddress = encodeURIComponent(addressFormated);
  return `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
}
